<template lang="pug">
  div
    header.header.public
      .header-logo(v-if="authenticated")
        router-link(:to="{ name: 'SearchJob' }")
          img(src="/static/images/logo_leadle.svg", alt="Leadle")
      .header-logo(v-else)
        router-link(:to="{ name: 'LandingPage' }")
          img(src="/static/images/logo_leadle.svg", alt="Leadle")
    .wrap.static
      .main
        .main-inner
          .title
            h2 Leadle 利用規約
          .box.wide
            p
              | 営業支援サービス『Leadle』のご利用は、本利用規約及び、 第２章 プライバシーポリシー をご承諾いただくことが条件となります。予め内容をご確認の上、ご利用ください。
            h3 第１章 利用規約
            h4 第１条（定義等）
            p
              | 利用規約・プライバシーポリシー（以下「本規約」という）に定める語句の定義は以下のとおりとします。
            ul
              li
                ul
                  li
                    | （１）「本サービス」とは、当社が運営する『Leadle』のサービスマーク、
                    | 商号等を付して行うパートナーへの情報掲載及び提供サービス、及びそれに付随するサービスの総称をいいます。
                  li
                    | （２）「パートナー」とは、本規約に同意のうえ本サービスの申し込みをし、かつ当社が本サービスの利用を承認した法人、個人及びその他の団体をいいます。
                  li
                    | （３）「通知」とは、電子メール・FAX・郵送等の情報伝達手段をいい、口頭で通知した場合には、
                    | 別途10日以内に書面を相手方へ提出するものとします。尚、通知は相手方の受領確認をもって到達したものとします。
                    | 但し、電子メールに限り、発信をもって相手方に到達したものとみなします。
            h4#section_2 第２条（本サービスの申込）
            ul
              li
                | １．パートナーは、本規約に同意のうえ、当社の定める申込書により本サービスの提供を申込むものとします。
              li
                | ２．当社は、前項の申し込みに対し、独自の基準により審査することができ、
                | 当該審査の結果、パートナーの申し込みを承認しない場合があります。尚、当該審査に関する質問等については、一切お答えできません。
            h4 第３条（本サービスの利用）
            ul
              li
                | １．本サービスの利用は、本規約の内容を全て承諾したうえで行われたものとみなします。
              li
                | ２．パートナーが本サービスに登録した情報は、自らがその内容について責任を負うものとします。
              li
                | ３．パートナーは、パートナーが本サービスに入力した情報等について、当社が本サービス向上のため、
                | 分析・解析等を実施すること、その結果を本サービスに活用すること
                | （統計データ等にて提供することを含むがこれに限らない）に同意するものとします。
            h4 第４条（ID及びパスワードの管理）
            ul
              li
                | １．パートナーは、本サービスに利用するID及びパスワードの利用及び管理については、自らの責任において行うものとし、当社は一切の責任を負わないものとします。
              li
                | ２．パートナーは、ID及びパスワードを第三者に公開、譲渡、売買及び貸与等をしてはなりません。
              li
                | ３．パートナーは、ID及びパスワードを失念した場合又は盗難若しくは漏洩等の可能性がある場合には、速やかに当社に通知するものとします。
              li
                | ４．ID及びパスワードの第三者使用等により、パートナーが損害を被った場合には、当社は一切の責任を負わないものとします。
            h4 第５条（本サービスの利用料金等）
            ul
              li
                | １．本サービスの利用料金は、申込書にて定めるものとします。
              li
                | ２．パートナーは当社に対し、申込書に定める期日までに（該当日が銀行の休業日の場合にはその前営業日とする）、
                | 当社の指定する銀行預金口座に振り込むものとします。尚、振込手数料はパートナーの負担とします。
              li
                | ３．一旦支払が完了した利用料金については、減額又は返金等は一切できません。
              li
                | ４．パートナーが、申込書に記載された支払期日までに利用料金を支払わなかった場合には、
                | 当社は、支払期日の翌日から起算して支払が完了した日まで年14.5％の割合の遅延損害金を請求することができるものとします。
                | 但し、別途損害賠償を請求することを妨げるものではありません。
            h4 第６条（禁止事項）
            p
              | パートナーは、本サービスの利用にあたり、以下の行為をしないものとします。
            ul
              li
                ul
                  li
                    | （１）本サービスの情報を第三者等に開示する行為。
                  li
                    | （２）本サービスの情報の内容の改変、二次利用等する行為。
                  li
                    | （３）本サービスの情報を転売等する行為。
                  li
                    | （４）本サービスを逆コンパイル、リバースエンジニアリング等の行為、本サービスのソースコード、構造等を解析、改変、他のソフトウェアと結合させる等の行為。
                  li
                    | （５）他のパートナー又は第三者等を誹謗、中傷する行為。
                  li
                    | （６）他のパートナー又は第三者等の著作権、商標権、プライバシー、その他の権利を侵害する行為。
                  li
                    | （７）本サービスの目的の範囲外の営利目的の情報収集等の行為。
                  li
                    | （８）本サービスの運営を妨げる行為、又はその虞のある行為。
                  li
                    | （９）当社の信用を棄損する行為、又はその虞のある行為。
                  li
                    | （10）犯罪行為、又はその虞のある行為。
                  li
                    | （11）公序良俗、法令等に違反する行為、又はその虞のある行為。
                  li
                    | （12）本規約に反する行為。
                  li
                    | （13）その他、当社が不適当と判断した行為。
            h4 第７条（本サービスの利用停止等）
            p
              | 当社は、以下の何れかに該当すると判断した場合、パートナーへの事前の通知をすることなく本サービスの利用の全部若しくは一部の利用禁止又は停止をできるものとします。
            ul
              li
                ul
                  li
                    | （１）パートナーが本規約に違反するとき。
                  li
                    | （２）当社が、本サービスの運営管理上必要と認めるとき。
                  li
                    | （３）理由の如何を問わず、本サービスの提供が終了したとき。
            h4 第８条（本サービスの利用責任）
            p
              | パートナーは、本サービスの利用により発生した第三者からの問い合わせ、苦情等については、
              | 本サービス提供中はもとより終了後に発生したものであっても、自らの費用と責任にてこれに対応するものとし、当社を免責するものとします。
            h4 第９条（本サービス及び利用規約の変更等）
            ul
              li
                | １．当社は、事前の通知なくして本サービスの変更、一時的もしくは長期的な停止、または終了をすることがあります。なお、当社はこれに伴う責任は一切負わないものとします。
              li
                | ２．当社は、随時本規約の変更をすることができるものとします。本規約の変更は、本サービス上に表示されたときをもって、変更された本規約が有効になるものとします。
            h4 第10条（知的財産権等）
            ul
              li
                | １．本サービスに関する所有権および著作権（著作権法第27条および28条所定の権利を含む）、
                | 特許権、商標権、意匠権等の一切の知的財産権を含むその一切の権利は、当社又は情報元に帰属します。
              li
                | ２．本サービスの利用は、当該知的財産権の利用許諾を意味するものではありません。
            h4 第11条（個人情報の取扱等）
            ul
              li
                | １．パートナーは、本サービスを通じて取得した個人情報の取り扱いについては、
                | プライバシーの保護に十分注意するとともに、善良な管理者の注意義務をもって企業秘密として管理するものとします。
              li
                | ２．パートナーは、本サービスを通じて取得した個人情報を、個人情報保護法及び関連法令等に基づいて許容された範囲内にて使用するものとします。
              li
                | ３．当社におけるパートナーの個人情報の取り扱いについては、別途定めるプライバシーポリシーに従うものとし、パートナーはこれに同意するものとします。
            h4 第12条  (共同利用)
            ul
              li
                | 1.共同利用する個人情報は、次に定める情報とします。
              li
                ul
                  li
                    | (1) 当社サービスにより取得する氏名、住所、性別、電話番号、メールアドレス、生年月日、家族構成等
                  li
                    | (2) クッキー情報、ログデータ等
              li
                | 2. 共同利用者の範囲は当グループのほか、当社と関連するサービスの提供会社（以下「関連サービス提供会社」といいます。）とします。
              li
                ul
                  li
                    | 共同利用者一覧  https://disruptors.co.jp/list/
              li
                | 3. 共同利用の目的は、次に定めるとおりとします。
              li
                ul
                  li
                    | (1)サービス実施のため
                  li
                    | (2)当グループまたは関連サービス提供会社の各社名義で行うマーケティング
                    | （当グループよび関連サービス提供会社の商品・サービス・アンケート等の電子メール発送、電話・SMS・SNSによる発信・連絡・通知、郵送によるダイレクトメール、電話または訪問によるご案内）
              li
                | 4. 利用者の個人情報共同利用の管理責任者は、次のとおりとします。なお、当社の所在地および代表者については以下の通りです。
              p
                | 共同利用に関する個人情報管理責任者：<br /><br />
                | 〒107-0062 東京都港区南青山二丁目５番17号<br />
                | 株式会社ディスラプターズ  代表取締役社長CEO  板倉  広高
                br
            h4 第13条（保存情報の取扱等）
            ul
              li
                | １．当社は、パートナーが本サービスに入力または保存したデータ（以下「登録情報」といいます。）について、細心の注意を払い、安全に管理するよう努めます。
                | 当社は、パートナーとの利用契約の有効期間中、当該パートナーの承諾を得ずに、サーバの故障、停止等の際に備えて登録情報をバックアップ保存することができ、
                | 当該ユーザーとの利用契約が終了した後もバックアップ保存をした登録情報を保存できるものとします。
                | また、当社は、バックアップした登録情報を任意に削除することができるものとし、
                | バックアップ保存をした登録情報を削除したことに起因してパートナーに何らかの損害が生じた場合であっても、一切の責任を負わないものとします。
              li
                | ２．第1項に拘らず、本サービスが本質的に情報の喪失、改変、破壊等の危険が内在するインターネット通信網を介したサービスであることに鑑みて、
                | パートナーは、登録情報を自らの責任においてバックアップするものとします。
                | 当該バックアップを怠ったことによってパートナーが被った損害について、当社は、送信情報の復旧を含めて、一切責任を負いません。
              li
                | ３．パートナーは、本サービスに入力、保存、アップロードするデータについて、ウイルス感染等のリスクがないことを保証し、
                | 万が一、ウイルス感染等を引き起こし、損害を発生した場合には、その一切の責任を負うものとします。
              li
                | 4．当社は、以下の目的のため、登録情報にアクセスを行うことがあります。
                | また、法令に従った要請（捜査関係事項照会書による要請を含む）や法令の手続上必要とされる場合については、全部または一部の登録情報を開示・公開することがあります。
              li
                ul.disc-list
                  li
                    | 本サービスのお客様へのサービス向上のため（本サービスの機能追加、改善または当社が提供する新たなサービスの開発を行う場合を含みます。）
                  li
                    | 本サービスの安全な運営のため
                  li
                    | 本サービスまたは本サービスのシステム上の問題を防止するため
                  li
                    | 本サービスのサポート上の問題に関連してお客様から当社に要請があった場合に、当該サポート上の問題を解決するため
                  li
                    | 本サービスの統計情報取得のため
              li
                | 5． 当社は、本サービスの提供及び運用に関する統計及び実績情報を得るために、登録情報及びパートナーによる本サービスの利用状況をモニターし、パートナー全体の傾向等を数量的に把握する目的で、
                | パートナーやパートナーの顧客が特定・識別されない形式に加工したうえで作成する統計的な情報（以下「統計情報」といいます。）を作成し、
                | パートナーに提供、公開することができるものとします。なお、統計情報に係る権利、所有権及び知的財産権は、すべて当社に帰属します。
            h4 第14条（免責等）
            ul
              li
                | １．当社は、本サービスについて、パートナーの想定している目的に適合していること、
                | バグや中断等の不具合のないこと、本サービスの利用がパートナーの想定している事項を達成すること
                | 又はその他のパートナーの要求に応えるものであることを一切保証しないものとします。
              li
                | ２．当社は、本サービスに関し、情報等の内容の最新性、真実性、正確性及び網羅性等を保証するものではなく、またその確認義務は負わないものとします。
              li
                | ３．前二項及び停電、通信回線の事故、天災等の不可抗力、通常講ずるべき対策では防ぎきれないウイルス感染、
                | システムトラブル又はメンテナンス等により本サービスを提供できなかった場合には、そこから発生する損害について、当社は一切免責されるものとします。
              li
                | ４．パートナーは、当社がパートナー以外の第三者と本サービスと同様の申込を承認することを、妨げられないものとします。
            h4 第15条（不可抗力等）
            p
              | パートナー及び当社は、管理可能な範囲を超えたシステム上の不具合、
              | 緊急メンテナンスの発生など自らの責に帰すべからざる事由に起因して、又は、天災、地変、
              | その他の不可抗力により、本規約に定められた義務の履行を妨げられた場合には、その範囲に限り当該不履行に基づく責任につき免除されるものとします。
            h4 第16条（秘密保持義務）
            ul
              li
                | １．パートナー及び当社は、本規約の内容及び本規約の履行過程において知り得た相手方の営業秘密に関する情報
                | （以下、「秘密情報」という）を、第三者に開示、提供又は漏洩してはならないものとします。
                | 但し、相手方の事前の書面による承認がある場合には、第三者に秘密情報を開示又は提供することができるものとします。
              li
                | ２．パートナー及び当社は、秘密情報を相手方の承認なしに、本規約に定める目的以外に使用してはならないものとします。
              li
                | ３．前二項に拘らず、以下の各号の一に該当する場合には、秘密情報には適用しないものとします。ただし、個人情報は除きます。
              li
                ul
                  li
                    | （１）開示を受けた際、秘密の義務を負うことなく既に自ら所有し又は第三者から入手していたもの。
                  li
                    | （２）開示を受けた際、既に公知又は公用であったもの。
                  li
                    | （３）開示を受けた後、パートナー又は当社の責によらないで公知又は公用となったもの。
                  li
                    | （４）当該情報から無関係にかつ独自に開発されたもの。
                  li
                    | （５）法律の規定又は裁判所若しくは政府機関の命令、要求に基づきその開示が要求されたもの。
              li
                | ４．パートナー及び当社は、本サービスの提供が終了した場合又は相手方から要求があった場合には、
                | 相手方から交付された秘密情報を含む資料（電子媒体等も含む）を廃棄、消去又は返却するものとします。
            h4 第17条（契約の効力発生、満了日及び更新）
            ul
              li
                | １．本サービスの提供期間は、申込書に別途記載が無い限り、
                | 申込書に記載された本サービス開始日から申込書に記載の契約期間有効に存続するものとします。
                | 但し、有効期間満了の１ヶ月前までに相手方から書面による別段の意思表示なき限り、同一条件でさらに申込書に記載の契約期間継続するものとし、以後も同様とします。
              li
                | ２．本サービス提供期間の終了時に未履行の債務がある場合には、尚、当該債務の履行が完了するまで本規約が適用されます。
              li
                | ３．第８条、第11条、第15条、第19条乃至第22条に関しては、本サービス提供期間終了後も有効に存続するものとします。
            h4 第18条（途中解約）
            ul
              li
                | 1. パートナー又は当社は、本サービスの提供期間中であっても、
                | 相手方に対し解約希望日の１ヶ月前までに書面にて通知することより、
                | 本サービスを将来に向かってのみ解約することができるものとします。
              li
                | 2. パートナーから解約を申し出た場合、
                | 申請日から契約期間満了日までの利用料の半額を、当社に支払うものとします。
            h4 第19条（契約解除）
            p
              | パートナー及び当社は、相手方が下記各号の一に該当する場合には、
              | 相手方に対する何らの催告なしに直ちに本サービス並びにパートナー及び当社間の他の契約の全部又は一部につき履行を停止し、
              | あるいは契約を解除することができるものとします。この場合、相手方に対する全ての債務（本規約による債務に限定されない）は、
              | 当然に期限の利益を失い、直ちに債務全額を現金にて相手方に支払わなければならないものとします。
              | 尚、パートナー又は当社は、それによる損害額を別途相手方に請求することができるものとします。
            ul
              li
                ul
                  li
                    | （１）本規約又はパートナー及び当社間の他の契約に定める義務の全部又は一部に違反し、
                    | 相手方からの是正を求める通知を受けたにも拘わらず、通知を受領した日より２週間以内に当該違反行為を是正しなかったとき。
                  li
                    | （２）差押え、仮差押え、仮処分、競売若しくは租税滞納処分等公権力の処分を受け、
                    | 又は監督官庁より営業停止あるいは営業免許若しくは営業登録の取消の処分を受けたとき。
                  li
                    | （３）破産、会社更生若しくは民事再生手続の申し立てがあったとき、又は清算（特別清算を含む）手続きに入ったとき。
                  li
                    | （４）解散（法令に基づく解散も含む）若しくは営業の全部又は重要な一部を第三者に譲渡しようとしたとき。
                  li
                    | （５）手形又は小切手を不渡としたとき、その他支払停止状態に至ったとき。
                  li
                    | （６）相手方が反社会的勢力であることを表明したとき、又は反社会的勢力ではないことの明確な回答をしないとき。
                  li
                    | （７）相手方が反社会的勢力ではないことを明確に表明した後、その申告が虚偽であることが判明したとき。
            h4 第20条（損害賠償）
            ul
              li
                | １．パートナー及び当社は、自らの責めに帰すべき事由により相手方に損害を与えた場合には、
                | 相手方が被った損害（直接かつ通常の損害に限る）を賠償する責任を負うものとします。
                | ただし、本規約により免責されているものについては、この限りではありません。
              li
                | ２．前項による損賠賠償の額は、パートナーが当社に支払った直近６ヶ月間の本サービス利用料を上限とします。
                | ただし、故意又は重過失により損害を相手方に与えた場合には、この限りではありません。
              li
                | ３．パートナー又は当社が、本規約に違反したことにより第三者に損害を与えた場合には、本規約に違反した当事者が自ら解決するものとし、相手方を免責するものとします。
            h4 第21条（管轄裁判所）
            p
              | パートナー及び当社は、本規約に関する訴訟を提起する場合、東京地方裁判所をもって専属的な管轄裁判所とすることに合意します。
            h4 第22条（譲渡等禁止）
            p
              | パートナー及び当社は、相手方の事前の書面による承認を得ない限り、本規約から生ずるいかなる債権も第三者に譲渡し、又は質入れをすることができないものとします。
            h4 第23条（協議）
            p
              | 本規約に定めのない事項及び本規約の解釈について疑義が生じた場合には、パートナー及び当社は、相互に誠意をもって協議し解決を図るものとします。

            h3 第２章 プライバシーポリシー
            p
              | 営業支援サービス『Leadle』のご利用は、本プライバシーポリシー及び、第1章 利用規約をご承諾いただくことが条件となります。予め内容をご確認の上、ご利用ください。
            h4 第１条（定義）
            p
              | 本規約にて個人情報とは、個人に関する情報であって、当該情報に含まれる氏名、
              | 生年月日その他の記述などによって特定の個人を識別できるもの（他の情報と容易に照合することができ、
              | それによって特定の個人を識別できるものを含む。）をいいます。
            h4 第２条（収集の目的）
            ul
              li
                | １．個人情報は、本サービスへのアカウント登録、サービスの品質向上を目的としたアンケートの実施、
                | その他本サービスに付随するサービスの提供を行うことを目的として、必要な範囲内にて収集します。
              li
                | ２．前項の利用目的の他、当社は、取得した個人情報を、業務提携または業務委託を行っている企業（以下「提携会社等」といいます）に提供し、提携会社等が提供する商品、サービス、イベント、セミナー等
                | （本サービス以外のものを含みます。）に関する情報提供、営業活動、マーケティング活動（属性情報、行動履歴分析、広告配信等を含みます）に利用することがあります。
              li
                | 3．本サービスでは、サービス向上のための分析や効果測定等のためにクッキーを使用しています。クッキーを拒否する場合、本サービスを使用できないことがあります。
              li
                | 4．本サービスの行動ターゲティング分析等を目的として、第三者が当該目的のためクッキーを利用して情報を取得する場合があります。この場合、個人情報は一切取得されません。
            h4 第３条（利用）
            p
              | 個人情報は、前条の目的の範囲内にて利用します。ただし、次に示すいずれかに該当する場合、この限りではありません。
            ul
              li
                ul
                  li
                    | （１）法令に基づく場合
                  li
                    | （２）人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
                  li
                    | （３）公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
                  li
                    | （４）国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、
                    | 本人の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがあるとき
            h4 第４条（提供）
            ul
              li
                | １．当社は、個人情報の提供を行う場合、個人情報の取扱いの安全性を図るため、個人情報の取扱いに関する条項を含む契約を各提供先と締結するものとします。
              li
                | ２．前条第２項に定める利用目的の範囲内において、当社は、取得した個人情報を提携会社等に提供することがあります。
              li
                | ３．前項に基づき提携会社等に個人情報を提供する場合は、電磁的な方法または書面等による方法で行うものとします。
            h4 第５条（個人情報を提供しなかった場合に生じる結果）
            p
              | 本サービスの利用は、本人の任意によるものとします。ただし、本サービスの利用において必須項目の入力又は申請がない場合、本サービスを利用できないことがあります。
            h4 第６条（管理）
            p
              | 当社は、個人情報への不正アクセス、個人情報の紛失、破壊、改竄および漏洩など、個人情報に関するリスクに関して合理的な安全対策を講じるものとします。
            h4 第７条（開示、訂正、削除）
            p
            ul
              li
                | １．本人の個人情報の開示は、いつでも当社に求めることができます。ただし、
                | 次に示すいずれかに該当する場合、開示請求内容の全部または一部を開示しないことができます。この場合、本人にその旨を遅滞なく通知するものとします。
              li
                ul
                  li
                    | （１）本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合
                  li
                    | （２）当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合
                  li
                    | （３）法令に違反することとなる場合
              li
                | ２．本人の個人情報の訂正、削除は、いつでも当社に求めることができます。
            h4 第８条（委託）
            p
              | 個人情報の取扱いを外部に委託する場合、委託先と機密情報保持契約を結ぶとともに、委託先の個人情報保護管理体制を十分に監督するものとします。
            h4 第９条（個人情報保護管理者）
            p
              | 個人情報は、以下の個人情報保護管理者が責任をもって管理するものとします。<br /><br />
              | 東京都港区南青山二丁目5-17 ポーラ青山ビルディング 13F<br />
              | 当社 管理部長<br /><br />
              | 個人情報に関するお問い合わせ先<br />
              | 当社 個人情報顧客相談窓口（E-mail：info@salesx.co.jp）<br />
              br
              | 以上

      footer.footer
        p.copyright
          | &copy; SalesX Inc. 2025
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        authenticated: 'session/authenticated',
      }),
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/TermsOfService.vue